
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {Injectable} from '@angular/core';
import {DocumentModel} from '../../../api/model/document.model';
import {DocumentConverter} from '../../../api/converter/document.converter';
import {AbstractDataServiceV2} from '../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';

@Injectable({
    providedIn: 'root'
})
export class DocumentDataService extends AbstractDataServiceV2<DocumentModel, DocumentConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: DocumentConverter) {
        super('Document', http, httpUrlGenerator, logger, config, converter);
    }
}
